// Core
import React, { useState, useRef, useEffect } from 'react';
import { Flex, Button, Box, Image, Grid, Text, Switch, Spinner, useDisclosure } from '@chakra-ui/react';

import { people } from '../../variables/data';

const Settigns = () => {
	return (
		<Box 
			maxH="100vh" 
			pt="16px" 
			pb="350px" 
			overflowY="auto">
			<Box>
			     <Grid templateColumns={{ base: '1fr 1fr' }} gap="8px" templateRows='1fr'>
			     	{ people[2].gallery.map((item, index) => (
			            <Image key={index} src={item} h="300px" objectFit="cover" borderRadius="16px" />
			        ))}

			        <Box borderRadius="16px" border="2px dashed #ccc" position="relative" w="100%" h="300px">
			        	<Text 
			        		left="50%"
			        		top="50%"
			        		transform="translate(-50%, -50%)"
			        		w="50px"
			        		color="#ccc"
			        		fontSize="76px"
			        		h="100px"
			        		position="absolute">
			        		+
			        	</Text>
			        </Box>
			     </Grid>
			</Box>
		</Box>
	);
};

export default Settigns;